import {FC} from "react";
import Address from "../../types/address";

const AddressCard: FC<{
  address: Address,
  selected: boolean,
  onSelect: (a: Address) => void
}> = ({
        address,
        selected,
        onSelect
      }) => {
  return (
    <>
      <div className="address" onClick={() => onSelect(address)}>
        {
          (address.attention &&
            address.attention.length > 0) &&
          <span>{`${address.attention}`}<br/></span>
        }
        {address.company.length > 0 && <span>{address.company}<br/></span>}
        <span>{`${address.address1}`}<br/></span>
        {address.address2.length > 0 && <span>{address.address2}<br/></span>}
        <span>{`${address.city}, ${address.state} ${address.postalCode}`}<br/></span>
        <span>{address.country}<br/></span>
      </div>
      {/*language=CSS*/}
      <style jsx>{`
        .address {
          padding: 15px;
          border: ${selected ? "2px solid #005E9E" : "1px solid rgb(194, 194, 194)"};
        }
      `}</style>
    </>
  )
}

export default AddressCard;
